'use client'

import classNames from 'classnames'
import type { HTMLAttributes, ReactNode } from 'react'

interface ITableHeaderProps extends HTMLAttributes<HTMLTableSectionElement> {
  className?: string
  children: ReactNode
}

export const PktTableHeader = ({ className, children, ...props }: ITableHeaderProps) => (
  <thead className={classNames(className, 'pkt-table__header', {})} role="rowgroup" {...props}>
    {children}
  </thead>
)
